import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import CustomTooltip from "./CustomTooltip";

const TrendAllPagesChart = ({ data, days, isLoading, onDaysChange }) => {
  return (
    <div className="chart-card">
      <div className="chart-header">
        <div className="chart-header-with-select">
          <div>
            <h3>Trend (All Pages)</h3>
            <p>Total daily page views over selected period</p>
          </div>
          <select
            className="days-selector"
            value={days}
            onChange={onDaysChange}
          >
            <option value={7}>Last 7 Days</option>
            <option value={10}>Last 10 Days</option>
            <option value={15}>Last 15 Days</option>
            <option value={30}>Last 30 Days</option>
          </select>
        </div>
      </div>
      <div className="chart-container" style={{ position: 'relative' }}>
        {isLoading && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 10
          }}>
            <div className="spinner" style={{ width: '32px', height: '32px' }}></div>
          </div>
        )}
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
            <XAxis dataKey="day" stroke="#666" />
            <YAxis stroke="#666" allowDecimals={false} />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <Line
              type="monotone"
              dataKey="visits"
              stroke="#ff9800"
              strokeWidth={3}
              name="Page Views"
              dot={{ fill: "#ff9800", r: 5 }}
              activeDot={{ r: 7 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default TrendAllPagesChart;
